import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

/**
 * Price — Page de retour post-onboarding Stripe Connect pour un
 * covoitureur. Appelée par Stripe à la fin (ou l'abandon) du flux
 * Stripe Express onboarding :
 *   • `?state=done`     → onboarding terminé (ou passé en pause)
 *   • `?state=refresh`  → le lien Stripe a expiré, l'utilisateur doit
 *                         redemander un nouveau lien dans l'app.
 *
 * L'onboarding s'ouvre dans un navigateur externe (Safari / Chrome)
 * depuis l'app Capacitor. Objectif : refermer la fenêtre pour revenir
 * dans l'app, et sinon afficher un message clair pour l'utilisateur
 * web avec un bouton de retour.
 */
export default function PriceStripeConnectReturn() {
  const [stage, setStage] = useState("closing");
  const params = new URLSearchParams(
    typeof window !== "undefined" ? window.location.search : "",
  );
  const state = params.get("state") || "done";
  const isDone = state === "done";

  useEffect(() => {
    // Tentative 1 : refermer la fenêtre (fonctionne quand le browser a
    // été ouvert par JS depuis l'app Capacitor). Dans ce cas l'app
    // détecte `browserFinished` et refresh le statut Stripe du driver.
    try { window.close(); } catch (_e) { /* ignore */ }

    // Tentative 2 : fallback web — on reste sur la page (pas de dash
    // driver côté marketing). On change juste le texte après 1,5s pour
    // indiquer que l'utilisateur peut fermer manuellement.
    const t = setTimeout(() => setStage("ready"), 1500);
    return () => clearTimeout(t);
  }, []);

  return (
    <main
      data-testid="price-stripe-connect-return"
      style={{
        minHeight: "100dvh",
        background: "#FFF8F1",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        fontFamily: "Outfit, system-ui, sans-serif",
      }}
    >
      <div
        style={{
          background: "white",
          borderRadius: 24,
          border: "2px solid #1E0910",
          boxShadow: "6px 6px 0 0 #1E0910",
          padding: 28,
          maxWidth: 420,
          width: "100%",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: 72,
            height: 72,
            margin: "0 auto 16px",
            borderRadius: 18,
            background: isDone ? "#D6F5D6" : "#FFEEDD",
            border: "2px solid #1E0910",
            display: "grid",
            placeItems: "center",
            fontSize: 36,
          }}
        >
          {isDone ? "✅" : "🔄"}
        </div>
        <h1
          style={{
            fontSize: 22,
            fontWeight: 900,
            margin: "0 0 8px",
            color: "#1E0910",
          }}
        >
          {isDone ? "Compte Stripe prêt !" : "Lien expiré"}
        </h1>
        <p
          style={{
            fontSize: 14,
            color: "rgba(30,9,16,0.65)",
            margin: "0 0 20px",
            fontFamily: "Manrope, system-ui, sans-serif",
          }}
        >
          {isDone
            ? stage === "closing"
              ? "Retour à l'application Price en cours…"
              : "Tu peux refermer cette page et retourner dans l'app Price pour commencer à recevoir des courses."
            : "Ton lien de configuration Stripe a expiré. Retourne dans l'app Price et clique à nouveau sur « Configurer Stripe » pour obtenir un nouveau lien."}
        </p>
        <Link
          to="/download"
          data-testid="stripe-return-to-app"
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            padding: "12px 20px",
            background: "#F86A78",
            color: "white",
            borderRadius: 14,
            border: "2px solid #1E0910",
            boxShadow: "4px 4px 0 0 #1E0910",
            fontWeight: 900,
            fontSize: 14,
            textDecoration: "none",
            textTransform: "uppercase",
            letterSpacing: 1,
          }}
        >
          Ouvrir l'app Price →
        </Link>
      </div>
    </main>
  );
}
